var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgReclassify = function SvgReclassify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.584 1.882A2.833 2.833 0 104.5 7.333h2.833V4.5a2.833 2.833 0 00-1.749-2.618zM6 4.5V6H4.5A1.5 1.5 0 116 4.5zm1.333 4.167H4.5A2.833 2.833 0 107.333 11.5V8.667zm-3.666 1.586A1.5 1.5 0 014.5 10H6v1.5a1.5 1.5 0 11-2.333-1.247zm9.837-7.757A2.834 2.834 0 008.667 4.5v2.833H11.5a2.834 2.834 0 002.004-4.837zm-1.17 3.251A1.5 1.5 0 0111.5 6H10V4.5a1.5 1.5 0 112.333 1.247zm-.834 2.92H8.667V11.5A2.833 2.833 0 1011.5 8.667z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reclassify_svg__clip0_230_3117"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgReclassify;